import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	max-width: 1030px;
	margin: 0 auto;
	position: relative;

	color: ${CSSVars.black};
	padding: 50px 20px;

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 100px 40px;
	}

	h2 {
		font-size: ${CSSVars.fontSize2XL};
		text-align: left;
		margin-bottom: 20px;
		max-width: 680px;
		margin-left: 0;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSize3XL};
		}
	}

	.form-wrapper {
		display: flex;
		align-items: center;
		gap: 10px;
		margin-top: 20px;
		max-width: 100%;
	}

	.search-components {
		margin: 0;
		flex: 1;

		input {
			height: 35px;
		}
	}

	.platform-results {
		position: absolute;
		width: 100%;
		max-width: 440px;
		margin-top: 15px;
		padding: 5px;
		border-radius: 10px;
		border: 1px solid #f0f0f0;
		background: #fcfcff;
		box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
		max-height: 220px;
		flex-direction: column;
		gap: 5px;
		overflow-y: auto;
		display: none;

		&.show {
			display: flex;
		}

		.platform {
			padding: 10px;
			border-radius: 5px;
			transition: 0.3s;
			display: flex;
			align-items: center;

			cursor: pointer;

			img {
				max-height: 20px;
			}

			&:hover,
			&.active {
				background: #e4eaff;
			}
		}
	}
`;
